import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { CreditService } from '../../services/credit/credit.service';
import { CreditDemande } from '../../interfaces/credit.interface';

/** L'onglet vit dans l'URL : la résolution charge directement la bonne liste. */
export const listCreditResolver: ResolveFn<CreditDemande[]> = (route: ActivatedRouteSnapshot) => {
  const tab = route.queryParamMap.get('tab');
  const action = tab === 'cloture' || tab === 'rejette' ? tab : undefined;
  return inject(CreditService).getListeDemandes(action);
};
